import styled from 'styled-components';

const Header = styled.h1`
  all: initial;
  margin-bottom: 25px;
  line-height: 1.4em !important;
  font-size: 18px !important;
  display: block;
`;

export default Header;
